module.exports = __webpack_public_path__ + "img/963_logotipo.1a95b404.webp";